import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-799026b3"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "t-hr" }, null, -1))
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "title-content" }
const _hoisted_4 = { class: "text-block" }
const _hoisted_5 = { class: "en-text" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hr-1" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hr-2" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "b-hr" }, null, -1))


export default /*#__PURE__*/_defineComponent({
  __name: 'pc-module-title-1',
  props: {
    innerText: { default: '大标题' },
    maxLine: { default: 1 },
    enInnerText: { default: 'Big Title' }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", {
            class: "text",
            style: _normalizeStyle({ '--max-line': _ctx.maxLine })
          }, _toDisplayString(_ctx.innerText), 5),
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.enInnerText), 1)
        ]),
        _hoisted_6,
        _hoisted_7,
        _hoisted_8
      ])
    ])
  ]))
}
}

})